import { AttributeValue } from "../../../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../../../library-js/dom-tools/ElementAttribute";
import { ElementSelector } from "../../../../../library-js/dom-tools/ElementSelector";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";
import { Property } from "../../../../../library-js/events/Property";
import { OnChange } from "../../../../../library-js/dom-tools/EventListeners";

export class ReminderInput extends DomElement<HTMLElement>
{
  static Text = new ElementType( "reminder-input-text" );
  static Label = new ElementType( "reminder-label" );
  static labelAttribute = new ElementAttribute( "label" );

  protected _label:DomElement<HTMLElement>;
  protected _input:DomElement<HTMLInputElement>;
  get input(){ return this._input;}

  readonly text = new Property<string>( "" );

  constructor( e:Element )
  {
    super( e as HTMLElement );
    this._label = new DomElement<HTMLElement>( ReminderInput.Label.query( e ) as HTMLElement );
    this._input = new DomElement<HTMLInputElement>( ElementType.input.query( e ) as HTMLInputElement );
    this.text.setValueSilently( this._input.element.value );
   
    OnChange.add( this._input.element, () => { this.text.value = this._input.element.value; } ); 
  }

  setTextSilently( text:string )
  {
    this._input.element.value = text;
    this.text.setValueSilently( text );
  }
  
  static getText( e:Element, label:string )
  {
    return new ReminderInput( new ElementSelector( ReminderInput.Text, new AttributeValue( this.labelAttribute, label ) ).query( e ) );
  }

  
}